/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { IPageContainerViewProps } from './page-container';
import { imageAlignment as EImageAlign } from './page-container.props.autogenerated';

const _imageColumn = (image: Msdyn365.IImageData, requestContext: Msdyn365.IRequestContext) => {
    return (
        <div
            className='pagebuilder-column'
            data-content-type='column'
            data-appearance='align-center'
            data-background-images='{}'
            data-element='main'
            style={{
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
                backgroundPosition: 'left top',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'scroll',
                textAlign: 'center',
                borderStyle: 'none',
                borderWidth: '1px',
                borderRadius: '0px',
                width: '50%',
                margin: '0px',
                padding: '10px',
                alignSelf: 'center'
            }}
        >
            <figure
                data-content-type='image'
                data-appearance='full-width'
                data-element='main'
                style={{
                    margin: '0px',
                    padding: '0px',
                    borderStyle: 'none'
                }}
            >
                <img
                    className='pagebuilder-mobile-hidden'
                    src={image.src}
                    alt={image.altText}
                    title={image.altText}
                    data-element='desktop_image'
                    style={{
                        borderStyle: 'none',
                        borderWidth: '1px',
                        borderRadius: '0px',
                        maxWidth: '100%',
                        height: 'auto'
                    }}
                />
                <img
                    className='pagebuilder-mobile-only'
                    src={image.src}
                    alt={image.altText}
                    title={image.altText}
                    data-element='mobile_image'
                    style={{
                        borderStyle: 'none',
                        borderWidth: '1px',
                        borderRadius: '0px',
                        maxWidth: '100%',
                        height: 'auto'
                    }}
                />
            </figure>
        </div>
    );
};
const _textColumn = (heading: string, description: Msdyn365.RichText, handleTextChange: any, requestContext: Msdyn365.IRequestContext) => {
    return (
        <div
            className='pagebuilder-column'
            data-content-type='column'
            data-appearance='align-center'
            data-background-images='{}'
            data-element='main'
            style={{
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
                backgroundPosition: 'left top',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'scroll',
                textAlign: 'center',
                borderStyle: 'none',
                borderWidth: '1px',
                borderRadius: '0px',
                width: '50%',
                margin: '0px',
                padding: '10px',
                alignSelf: 'center'
            }}
        >
            <h2
                data-content-type='heading'
                data-appearance='default'
                data-element='main'
                style={{
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    fontFamily: 'Poppins-Medium, sans-serif',
                    fontSize: '2.4rem',
                    fontWeight: 400,
                    color: '#575757',
                    textTransform: 'none',
                    marginTop: 0
                }}
            >
                {heading}
            </h2>
            <div
                data-content-type='text'
                data-appearance='default'
                data-element='main'
                style={{
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px',
                    padding: '0px',
                    fontSize: '1.2rem'
                }}
            >
                <Msdyn365.RichTextComponent text={description} editProps={{ onEdit: handleTextChange, requestContext: requestContext }} />
            </div>
        </div>
    );
};

export default (props: IPageContainerViewProps) => {
    const { description, title, image, imageAlignment } = props;
    const { request } = props.context;
    const handleTextChange = (event: Msdyn365.ContentEditableEvent) => (props.config.description = event.target.value);
    let left, right;
    if (imageAlignment === EImageAlign.left) {
        left = _imageColumn(image ? image : {}, request);
        right = _textColumn(title ? title : '', description ? description : '', handleTextChange, request);
    } else {
        left = _textColumn(title ? title : '', description ? description : '', handleTextChange, request);
        right = _imageColumn(image ? image : {}, request);
    }
    return (
        <div data-content-type='row' data-appearance='contained' data-element='main'>
            <div
                data-enable-parallax='0'
                data-parallax-speed='0.5'
                data-background-images='{}'
                data-background-type='image'
                data-video-loop='true'
                data-video-play-only-visible='true'
                data-video-lazy-load='true'
                data-video-fallback-src=''
                data-element='inner'
                style={{
                    justifyContent: 'flex-start',
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundPosition: 'left top',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundAttachment: 'scroll',
                    borderStyle: 'none',
                    borderWidth: '1px',
                    borderRadius: '0px',
                    margin: '0px 0px 10px',
                    padding: '10px'
                }}
            >
                <div
                    className='pagebuilder-column-group'
                    data-content-type='column-group'
                    data-grid-size='12'
                    data-element='main'
                    style={{
                        display: 'flex'
                    }}
                >
                    {left}
                    {/*  */}
                    {right}
                </div>
            </div>
        </div>
    );
};
